import apiDirector from '../components/ApiDirector';

export const fetchMarket = (marketId) => new Promise((resolve, reject) => apiDirector.fetch(
  `market/${marketId}`,
  { blocking: false },
)
  .then((response) => response.json()
    .then((json) => {
      if (json) {
        resolve(json.market);
      } else {
        reject(new Error('Invalid JSON fetching market'));
      }
    })));

const fattenDirectVendor = (vendor) => {
  const { products, direct_locations: directLocations } = vendor;
  let categories = [];
  products
    .filter((product) => (product.product_status.id === 1))
    .forEach((product) => {
      const { product_category: category } = product;
      if (!categories.find((c) => (c.id === category.id))) {
        // this category isn't in my categories array
        categories.push({ ...category, products: [] });
      }
      // the category will definitely exist here
      categories.find((c) => (c.id === category.id)).products.push(product);
    });
  categories = categories
    .sort((c) => (c.sort_key))
    .filter((c) => (c.products.length !== 0));
  const directEvents = directLocations
    .map((directLocation) => directLocation.market_events.map(
      (me) => ({
        ...me,
        directLocation,
      }),
    ))
    .flat();
  return ({
    ...vendor,
    categories,
    directEvents,
  });
};

export const fetchDirectVendor = (slug) => new Promise((resolve, reject) => apiDirector.fetch(
  `direct_vendor/${slug}`,
  { blocking: false },
)
  .then((response) => response.json()
    .then((json) => {
      if (json) {
        resolve(fattenDirectVendor(json.vendor));
      } else {
        reject(new Error('Invalid JSON fetching direct vendor'));
      }
    })));

export const isEmpty = (obj) => (obj
  && Object.keys(obj).length === 0
  && obj.constructor === Object);
